import { render } from "./EmployeeView.vue?vue&type=template&id=74c98994&scoped=true"
import script from "./EmployeeView.vue?vue&type=script&lang=js"
export * from "./EmployeeView.vue?vue&type=script&lang=js"

import "./EmployeeView.vue?vue&type=style&index=0&id=74c98994&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c98994"]])

export default __exports__